import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import { Button, Col, Icon } from '../Component';
import TextInput from '../../pages/components/inputs/TextInput';
import { formatNumber, messageToast } from '../../utils/Utils';
import { TENANT_EDIT_ORDER_ITEM_API } from '../../api/api_data';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { fail_tenant_edit_order_units, loading_tenant_edit_order_units, reset_tenant_edit_order_units, success_tenant_edit_order_units } from '../../reducers/auth_tenant/tenant_edit_order_units_Slice';
import { TENANT_UPDATE_ORDER_UNITS_ERROR_MSG, TENANT_UPDATE_ORDER_UNITS_SUCCESS_MSG } from '../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import * as app_consts from "../../utils/app_consts";

const initialState = { order_item_id: "", new_units: "", reason: "", total_new_units_value: "" };

const TenantEditOrderItemUnitsModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

 const [open, setOpen] = useState(isOpen);
 const [loading, setLoading] = useState(false);
 const dispatch = useDispatch();
 const [error, setError] = useState("");
 const [formData, setFormData] = useState(initialState);
 const [page_data, setPagData] = useState(data);


 useEffect(() => {
  setOpen(isOpen);
  setFormData(initialState);
  setPagData(data);
  console.log(data);
 }, [isOpen]);

 const handleChange = (e) => {

  if (e.target?.name === "new_units")
  {
   const new_total_value = (e.target.value || 0) * (page_data?.unit_value || 0);
   setFormData({ ...formData, [e.target.name]: e.target.value, total_new_units_value: new_total_value });
  }
  else
  {
   setFormData({ ...formData, [e.target.name]: e.target.value });
  }
 };

 const confirmClick = () => {
  setError("");
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_tenant_edit_order_units, success_tenant_edit_order_units, fail_tenant_edit_order_units, TENANT_UPDATE_ORDER_UNITS_ERROR_MSG, TENANT_UPDATE_ORDER_UNITS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_EDIT_ORDER_ITEM_API}`, { ...formData, order_item_id: page_data?.id }));
 };

 // Listener
 const tenant_edit_order_units_listener = useSelector((state) => state.tenant_edit_order_units.tenant_edit_order_units);

 useEffect(() => {
  if (tenant_edit_order_units_listener.status !== app_consts.IDLE)
  {
   if (tenant_edit_order_units_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    if (tenant_edit_order_units_listener.status === app_consts.FAIL)
    {
     setLoading(false);
     setError(tenant_edit_order_units_listener.message);
     messageToast(tenant_edit_order_units_listener.message, app_consts.FAIL);
    } else if (tenant_edit_order_units_listener.status === app_consts.SUCCESS)
    {
     messageToast(TENANT_UPDATE_ORDER_UNITS_SUCCESS_MSG, app_consts.SUCCESS);
     successFunction();
     closeModal();
    }
    dispatch(reset_tenant_edit_order_units());
   }
  }
 }, [tenant_edit_order_units_listener]);

 return (
  <>
   <Modal isOpen={open} className="modal-dialog-centered" size={"md"} >
    <ModalHeader toggle={loading ? "" : closeModal}>{`Edit Order Item ${page_data && (`${page_data?.product?.name} (${page_data?.product?.category})`)} ?`}</ModalHeader>
    <ModalBody>
     <Row className="g-4">
      {error && (
       <div className="mb-3 w-100">
        <Alert color="danger" className="alert-icon">
         <Icon name="alert-circle" /> {error}{" "}
        </Alert>
       </div>
      )}
      <TextInput
       colSize={6}
       parentClassName="mt-2"
       label="Product"
       type="text"
       id_val="input"
       name="input"
       disabled
       value={page_data?.product?.name || "--"}
      />
      <TextInput
       colSize={6}
       parentClassName="mt-2"
       label="Brand"
       type="text"
       id_val="input"
       name="input"
       disabled
       value={page_data?.product?.category || "--"}
      />
      <TextInput
       colSize={6}
       parentClassName="mt-2"
       label="Product Type"
       type="text"
       id_val="input"
       name="input"
       disabled
       value={page_data?.product?.product_type || "--"}
      />
      <TextInput
       colSize={6}
       parentClassName="mt-2"
       label="Color"
       type="text"
       id_val="input"
       name="input"
       disabled
       value={page_data?.color || "--"}
      />
      <TextInput
       colSize={6}
       parentClassName="mt-2"
       label="Current Units"
       type="text"
       id_val="input"
       name="input"
       disabled
       value={page_data?.units || "--"}
      />
      <TextInput
       colSize={6}
       parentClassName="mt-2"
       label="Unit Value (ZMW)"
       type="text"
       id_val="input"
       name="input"
       disabled
       value={formatNumber(page_data?.unit_value || 0) || "--"}
      />
      <TextInput
       colSize={6}
       parentClassName="mt-2"
       label="Total Unit Value (ZMW)"
       type="text"
       id_val="input"
       name="input"
       disabled
       value={page_data?.total_value || "--"}
      />
      <TextInput
       colSize={6}
       parentClassName="mt-2"
       label="New Units"
       type="number"
       id_val="new_units"
       handleChange={handleChange}
       name="new_units"
       required
      />
      <TextInput
       colSize={6}
       parentClassName="mt-2"
       label="New Total Units Value"
       type="text"
       id_val="new_units"
       name="new_units"
       value={formatNumber(formData?.total_new_units_value) || 0}
       disabled
      />
      <TextInput
       colSize={12}
       parentClassName="mt-2"
       label="Reason"
       type="text"
       id_val="reason"
       handleChange={handleChange}
       name="reason"
       required
      />
      <Col xl="12" className="d-flex justify-between mt-4 mr-2">
       <Button onClick={() => { setOpen(!isOpen); }} className="btn-secondary">No</Button>
       <Button onClick={confirmClick} disabled={loading || !(formData?.reason && formData?.new_units)} className=" btn-primary ">
        {loading ? <Spinner size="sm" /> : "Edit Order Item Units"}
       </Button>
      </Col>
     </Row>
    </ModalBody>
   </Modal>
  </>
 );
};

export default TenantEditOrderItemUnitsModal;